module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/right-giftset_3f818d.png";